import type { ID as AccountID } from '../account'

export namespace GoogleSearchConsoleTypes {
    export interface GscApiConnectionDetails {
        siteUrl: string | null
        gscAccountId: AccountID | null
    }

    export interface AuthorizationResult {
        code?: string
        error?: string
        state?: string
    }

    export enum Error {
        NO_REFRESH_TOKEN = 'No google search console refresh token found',
        INVALID_TOKEN = 'Invalid google search console token',
        COULD_NOT_READ_RECENTLY_INSERTED_TOKEN = 'Could not read recently inserted google search console token',
        REVOKING_TOKEN = 'Failed to get google search console account data after storing token, revoking token',
        NO_LINKED_PROFILE_FOUND = 'No linked google search console profile was found',
        ACCESS_DENIED = 'User cancelled authorization',
        NO_AUTHORIZATION_CODE = 'We received no authorization code and google did not provide any error',
        NO_ACCESS_TOKEN = 'Something unexpected happened and we received no access token after authorization',

        // User facing messages
        EMAIL_WITHOUT_SEARCH_CONSOLE = 'The email address you selected has no associated Google search console account. If it does, please contact support.',
        ACCESS_TOKEN_SCOPE_INSUFFICIENT = 'Authorization failed due to insufficient permissions.',
        UNKNOWN_ERROR = 'An unknown error occurred while linking your Google search console account. Please contact support.',
    }

    export interface UsersRefreshTokenAndEmail {
        refresh_token: string
        email: string
        google_search_console_refresh_token_id: string
    }

    export interface SavedAccountIdsLegacy {
        profile_id: number
        property_id: string
        account_id: number
    }

    export type SavedAccountIds = {
        profileId: number
        propertyId: string
        accountId: number
    }

    export interface ActiveGAConnections {
        connected_domains: number
    }

    export enum MatadataEntityType {
        Account,
        Property,
        Profile,
    }

    export interface MatadataEntityBase {
        id: string
        name: string
    }

    export interface FormattedAccountData extends MatadataEntityBase {
        properties: FormattedAccountProperty[]
    }

    export interface FormattedAccountProperty extends MatadataEntityBase {
        profiles: MatadataEntityBase[]
    }

    export interface FormattedAccount {
        accounts: FormattedAccountData[]
    }

    export interface Credentials {
        accessToken: string
        connectionId: string
        email: string
    }

    export interface SearchConsoleSite {
        siteUrl: string
        permissionLevel: string
        gscTimezone: string
    }

    export interface SearchAnalyticsQuery {
        siteUrl: string
        startDate: string
        endDate: string
        dimensions?: string[]
        rowLimit?: number
        startRow?: number
    }
}
